import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, Phone, MessageCircle, ArrowRight, Award, Users, Clock, TrendingUp } from 'lucide-react';

const Home = () => {
  const services = [
    {
      title: 'Immobilien',
      description: 'Professionelle Immobilienverwaltung, Vermietung und Verkauf in Graubünden.',
      image: 'https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwbW9kZXJuJTIwaG91c2UlMjBleHRlcmlvciUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NzYyOTk0NHww&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/immobilien'
    },
    {
      title: 'Malerarbeiten',
      description: 'Professionelle Malerarbeiten für Innen- und Außenbereiche mit höchster Qualität.',
      image: 'https://images.unsplash.com/photo-1516962080544-eac695c93791?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHx3YWxsJTIwcGFpbnRpbmclMjByb2xsZXIlMjB3aGl0ZSUyMGludGVyaW9yJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3Nzc2Mjk5NDJ8MA&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/malerarbeiten'
    },
    {
      title: 'Bodenbeläge',
      description: 'Parkett, Laminat und Vinyl – professionell verlegt für Ihr Zuhause.',
      image: 'https://images.unsplash.com/photo-1761053133165-0f3acdaf1770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxwYXJxdWV0JTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb24lMjB3b29kJTIwZmxvb3IlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzc2NDMxODh8MA&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/bodenbelaege'
    },
    {
      title: 'Trockenbau',
      description: 'Moderne Trockenbauarbeiten für flexible Raumgestaltung.',
      image: 'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/je9ovspj_WhatsApp%20Image%202026-05-01%20at%2010.45.51%20%282%29.jpeg',
      path: '/leistungen/trockenbau'
    },
    {
      title: 'Fliesen & Naturstein',
      description: 'Hochwertige Fliesen- und Natursteinarbeiten für Bad und Küche.',
      image: 'https://images.unsplash.com/photo-1759223607861-f0ef3e617739?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHx0aWxlJTIwaW5zdGFsbGF0aW9uJTIwYmF0aHJvb20lMjBtYXJibGUlMjBuYXR1cmFsJTIwc3RvbmUlMjBmbG9vcnxlbnwwfHx8fDE3Nzc2NDMxODl8MA&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/fliesen-naturstein'
    },
    {
      title: 'Fassaden',
      description: 'Fassadengestaltung und -sanierung für bleibenden Eindruck.',
      image: 'https://images.unsplash.com/photo-1672847863750-1865a99b1787?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGZhY2FkZSUyMHNjYWZmb2xkaW5nJTIwcmVub3ZhdGlvbiUyMHBhaW50aW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc3NjI5OTUxfDA&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/fassaden'
    },
    {
      title: 'Türen & Fenster',
      description: 'Fachgerechte Montage von Türen, Fenstern und Rollläden.',
      image: 'https://images.unsplash.com/photo-1717997695609-a0a5a515991d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3aW5kb3clMjBpbnN0YWxsYXRpb24lMjBob3VzZSUyMHJlbm92YXRpb24lMjBkb29yfGVufDB8fHx8MTc3NzY0MzE5MHww&ixlib=rb-4.1.0&q=85',
      path: '/leistungen/tueren-fenster'
    }
  ];

  const reviews = [
    {
      name: 'Boris Jung',
      rating: 5,
      text: 'Ich bin äußerst zufrieden mit den Malerarbeiten und dem Trockenbau. Die Qualität ist hervorragend und das Team war sehr professionell.',
      date: 'vor 2 Monaten'
    },
    {
      name: 'Riccardo Muro',
      rating: 5,
      text: 'Wir waren sehr zufrieden mit der Arbeit. Alles wurde termingerecht fertiggestellt. Super geputzt!',
      date: 'vor 3 Monaten'
    },
    {
      name: 'Anna Müller',
      rating: 5,
      text: 'Professionelle Beratung und exzellente Ausführung. Sehr empfehlenswert für Renovationsarbeiten!',
      date: 'vor 1 Monat'
    }
  ];

  const stats = [
    { icon: Users, value: '8+', label: 'Erfahrene Mitarbeiter' },
    { icon: Award, value: '500+', label: 'Erfolgreiche Projekte' },
    { icon: Clock, value: '24h', label: 'Antwortzeit' },
    { icon: TrendingUp, value: '100%', label: 'Kundenzufriedenheit' }
  ];

  const features = [
    { icon: CheckCircle2, text: 'Kostenlose Beratung vor Ort' },
    { icon: CheckCircle2, text: 'Transparente Preisgestaltung' },
    { icon: CheckCircle2, text: 'Termingerechte Fertigstellung' },
    { icon: CheckCircle2, text: 'Qualitätsgarantie' },
  ];

  return (
    <div className="min-h-screen" data-testid="home-page">
      {/* Hero Section - Modern Split Design */}
      <section className="relative min-h-screen flex items-center overflow-hidden bg-white" data-testid="hero-section" style={{ maxWidth: '100vw' }}>
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZSUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NTAzMzg2M3ww&ixlib=rb-4.1.0&q=85"
            alt="Modern Architecture"
            className="w-full h-full object-cover opacity-15"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-gray-50/90 to-white/95"></div>
        </div>
        
        <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-8 py-24 md:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center w-full">
            {/* Left: Main Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="w-full"
            >
              {/* Experience Badge */}
              <motion.div 
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="inline-flex items-center gap-2 md:gap-3 bg-[#FFD700] text-black px-4 md:px-6 py-2 md:py-3 mb-6 md:mb-8 shadow-lg text-xs md:text-sm"
              >
                <Award className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" />
                <span className="font-heading font-bold uppercase tracking-wider whitespace-nowrap">
                  10+ Jahre Erfahrung ⭐⭐⭐⭐⭐
                </span>
              </motion.div>

              <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.1] mb-6 md:mb-8 text-[#003B7A] break-words" data-testid="hero-title" style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
                Professionelle<br/>
                <span className="text-[#003B7A]">Immobilien&shy;verwaltung</span><br/>
                <span className="text-[#003B7A]">& Bauarbeiten</span>
              </h1>
              
              <p className="font-body text-sm md:text-base lg:text-lg xl:text-xl leading-relaxed text-gray-700 mb-8 md:mb-10 max-w-xl" data-testid="hero-description">
                Seit Jahren Ihr zuverlässiger Partner für Qualität, Form und Funktion in Cazis und ganz Graubünden.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-8 md:mb-12 w-full">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center justify-center gap-2 bg-[#FFD700] text-black px-5 md:px-6 lg:px-8 py-3 md:py-4 text-xs md:text-sm font-bold uppercase tracking-wider hover:bg-[#FFC700] transition-all duration-300 shadow-lg hover:shadow-xl group w-full sm:w-auto"
                  data-testid="hero-cta-primary"
                >
                  <span className="text-center">Kostenlose Beratung vereinbaren</span>
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
                </Link>
                <Link
                  to="/leistungen/immobilien"
                  className="inline-flex items-center justify-center gap-2 bg-white text-black px-5 md:px-6 lg:px-8 py-3 md:py-4 text-xs md:text-sm font-bold uppercase tracking-wider border-2 border-gray-300 hover:border-[#FFD700] transition-all duration-300 group w-full sm:w-auto"
                  data-testid="hero-cta-secondary"
                >
                  <span>Referenzen ansehen</span>
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
                </Link>
              </div>
            </motion.div>

            {/* Right: Stats Box */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="relative w-full"
            >
              <div className="bg-white/90 backdrop-blur-xl p-6 md:p-8 lg:p-12 shadow-2xl border border-gray-200 w-full">
                {/* Main Stat */}
                <div className="text-center mb-6 md:mb-8 lg:mb-12 pb-6 md:pb-8 lg:pb-12 border-b border-gray-200">
                  <motion.div 
                    initial={{ scale: 0.5, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 0.5, type: "spring" }}
                    className="text-6xl md:text-7xl lg:text-[100px] xl:text-[120px] font-heading font-extrabold leading-none text-[#FFD700] mb-2"
                  >
                    10+
                  </motion.div>
                  <p className="text-base md:text-lg lg:text-xl font-body text-gray-600 uppercase tracking-wider">Jahre Erfahrung</p>
                </div>

                {/* Additional Stats */}
                <div className="grid grid-cols-2 gap-4 md:gap-6 lg:gap-8 mb-6 md:mb-8 lg:mb-12">
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-[#FFD700] mb-2">8</div>
                    <p className="text-xs md:text-sm font-body text-gray-600 uppercase">Mitarbeiter</p>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-[#25D366] mb-2">500+</div>
                    <p className="text-xs md:text-sm font-body text-gray-600 uppercase">Projekte</p>
                  </div>
                </div>

                {/* Description */}
                <p className="text-center text-xs md:text-sm font-body text-gray-600 leading-relaxed mb-4 md:mb-6 lg:mb-8">
                  Marali Immobilien AG & Baufirma wird von erfahrenen Fachkräften geführt. Mit gleichem Engagement für Qualität.
                </p>

                {/* Google Reviews Button */}
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Marali+Immobilien+AG+Baufirma+Cazis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 md:gap-3 w-full bg-white border-2 border-gray-300 py-3 md:py-4 hover:border-[#FFD700] transition-all duration-300 group"
                  data-testid="hero-google-reviews"
                >
                  <svg className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 flex-shrink-0" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                  </svg>
                  <span className="font-body font-semibold text-xs md:text-sm uppercase tracking-wider text-gray-700 group-hover:text-[#FFD700] transition-colors">
                    Bewertungen ansehen
                  </span>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="bg-[#003B7A] py-16" data-testid="stats-section">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="text-center"
                  data-testid={`stat-${index}`}
                >
                  <Icon className="w-10 h-10 text-[#FFD700] mx-auto mb-4" />
                  <p className="font-heading font-bold text-4xl text-white mb-2">{stat.value}</p>
                  <p className="font-body text-sm text-gray-400">{stat.label}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 md:py-32 bg-white" data-testid="services-section">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <p className="font-body text-xs tracking-[0.3em] uppercase text-[#FFD700] mb-4" data-testid="services-subtitle">
              Unsere Expertise
            </p>
            <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight mb-6" data-testid="services-title">
              Premium Leistungen für Ihr Projekt
            </h2>
            <p className="font-body text-base md:text-lg leading-relaxed text-gray-600 max-w-3xl mx-auto" data-testid="services-description">
              Von klassischen Malerarbeiten bis zu modernen Trockenbau-Lösungen – wir bieten das komplette Spektrum professioneller Bauleistungen.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`service-card-${index}`}
              >
                <Link to={service.path} className="service-card block group relative overflow-hidden bg-[#F5F5F7] h-[400px] flex flex-col justify-end">
                  <div className="absolute inset-0 overflow-hidden">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#003B7A]/90 via-[#003B7A]/50 to-transparent"></div>
                  </div>
                  <div className="relative z-10 p-8">
                    <h3 className="font-heading font-semibold text-2xl md:text-3xl mb-3 text-white group-hover:text-[#FFD700] transition-colors">
                      {service.title}
                    </h3>
                    <p className="font-body text-sm text-gray-300 mb-4">{service.description}</p>
                    <span className="inline-flex items-center gap-2 text-[#FFD700] text-sm font-bold uppercase tracking-wider group-hover:gap-4 transition-all">
                      Mehr erfahren <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/kontakt"
              className="inline-block bg-[#003B7A] text-white px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#FFD700] transition-all duration-300 shadow-lg"
              data-testid="services-cta"
            >
              Jetzt beraten lassen
            </Link>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section className="py-24 md:py-32 bg-[#F5F5F7]" data-testid="why-us-section">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <p className="font-body text-xs tracking-[0.3em] uppercase text-[#FFD700] mb-4" data-testid="why-us-subtitle">
                Warum Marali Immobilien AG?
              </p>
              <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight mb-6" data-testid="why-us-title">
                Qualität, die überzeugt
              </h2>
              <p className="font-body text-base md:text-lg leading-relaxed text-gray-600 mb-8" data-testid="why-us-description">
                Mit 8 erfahrenen Mitarbeitern und jahrelanger Expertise sind wir Ihr zuverlässiger Partner für alle Bau- und Renovationsprojekte in Graubünden.
              </p>
              <ul className="space-y-4">
                {features.map((feature, index) => {
                  const Icon = feature.icon;
                  return (
                    <li key={index} className="flex items-center gap-4" data-testid={`feature-${index}`}>
                      <Icon className="w-6 h-6 text-[#FFD700] flex-shrink-0" />
                      <span className="font-body text-base text-gray-700">{feature.text}</span>
                    </li>
                  );
                })}
              </ul>
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <a
                  href="tel:+41792649063"
                  className="inline-flex items-center justify-center gap-2 bg-[#003B7A] text-white px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#FFD700] transition-all duration-300"
                  data-testid="why-us-phone-cta"
                >
                  <Phone className="w-5 h-5" />
                  +41 79 264 90 63
                </a>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative"
            >
              <img 
                src="https://images.unsplash.com/photo-1707050296144-20fedfd194b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZSUyMHN3aXR6ZXJsYW5kfGVufDB8fHx8MTc3NTAzMzg2M3ww&ixlib=rb-4.1.0&q=85"
                alt="Professional Work"
                className="w-full h-[500px] object-cover shadow-2xl"
              />
              <div className="absolute -bottom-8 -right-8 bg-[#FFD700] text-white p-8 shadow-xl max-w-xs">
                <p className="font-heading font-bold text-3xl mb-2">100%</p>
                <p className="font-body text-sm">Kundenzufriedenheit durch höchste Qualitätsstandards</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-24 md:py-32 bg-white" data-testid="reviews-section">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <div className="flex items-center justify-center gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-8 h-8 fill-[#FFD700] text-[#FFD700]" />
              ))}
            </div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight mb-4" data-testid="reviews-title">
              5.0 Sterne auf Google
            </h2>
            <p className="font-body text-base md:text-lg text-gray-600" data-testid="reviews-subtitle">
              Das sagen unsere zufriedenen Kunden
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-[#F5F5F7] p-8 shadow-sm hover:shadow-md transition-shadow"
                data-testid={`review-card-${index}`}
              >
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" />
                  ))}
                </div>
                <p className="font-body text-base text-gray-700 mb-6 leading-relaxed">
                  "{review.text}"
                </p>
                <div className="border-t border-gray-300 pt-4">
                  <p className="font-heading font-semibold text-base text-[#003B7A]">{review.name}</p>
                  <p className="font-body text-xs text-gray-500">{review.date}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://www.google.com/maps/place/Marali+Immobilien+AG/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-transparent border-2 border-[#003B7A] text-[#003B7A] px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#003B7A] hover:text-white transition-all duration-300"
              data-testid="reviews-google-link"
            >
              Google Bewertungen ansehen
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[#003B7A] text-white" data-testid="cta-section">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight mb-6" data-testid="cta-title">
              Bereit für Ihr Projekt?
            </h2>
            <p className="font-body text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-testid="cta-description">
              Kontaktieren Sie uns jetzt für eine kostenlose Beratung. Antwort innerhalb von 24 Stunden garantiert.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/kontakt"
                className="bg-[#FFD700] text-white px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#c19d2f] transition-all duration-300 shadow-lg"
                data-testid="cta-contact"
              >
                Gratis Angebot in 24h
              </Link>
              <a
                href="https://wa.me/41792649063"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white px-8 py-4 text-sm font-bold tracking-widest uppercase hover:bg-[#1ea952] transition-all duration-300 flex items-center justify-center gap-2"
                data-testid="cta-whatsapp"
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp Nachricht
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;